import { c as _c } from "react-compiler-runtime";
import { useEffect, useMemo } from 'react';
import listingLibPerformanceTracking from 'framework-listing-lib/internal/utils/performanceTracking';
import useCrmObjectTypeTracking from './useCrmObjectTypeTracking';
export function useSyncPerformanceTracking() {
  "use memo";

  const $ = _c(2);
  const {
    trackPerformanceInteraction
  } = useCrmObjectTypeTracking();
  let t0;
  if ($[0] !== trackPerformanceInteraction) {
    t0 = () => {
      trackPerformanceInteraction();
    };
    $[0] = trackPerformanceInteraction;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(t0);
}
export default function usePerformanceTracking(metricName) {
  "use memo";

  const $ = _c(2);
  let t0;
  if ($[0] !== metricName) {
    t0 = listingLibPerformanceTracking.getPerformanceTracking(metricName);
    $[0] = metricName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const performanceTracking = t0;
  performanceTracking.markTimeStart();
  return performanceTracking;
}